// import React, { useContext, useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import Button from 'components/comman/button';
// import 'stylesheets/home2.scss';
// import { Images } from 'constants/Images';
// import { UserContext } from 'components/UserContext';
// import { API } from 'API/API';
// import { toast } from 'react-toastify';
// import ContactSaleModal from 'components/modal/ContactSaleModal';
// import homePageBanner from 'assets/images/Group 295 (4).svg';
// import rectIcon from 'assets/images/Rectangle 80.svg';
// import crossIcon from 'assets/images/Group 297.svg'
// const serviceData = [
//     {
//         id: 1,
//         title: 'Product Catalogue',
//         text: 'Find BIM, CAD and other technical product information for products found in our catalog.',
//         img: Images.image.serviceImg1,
//         path: '/products',
//         button: 'Search for Products',
//         modal: false
//     },
//     {
//         id: 2,
//         title: 'Project Builder',
//         text: 'Add products to your project and receive a detailed Project Submittal.',
//         img: Images.image.serviceImg2,
//         path: '/projects',
//         button: 'Start a project',
//         modal: false
//     },
//     {
//         id: 3,
//         title: 'Contact Us',
//         text: 'Find additional product information, new products, smart solutions, support and resources.',
//         img: Images.image.serviceImg3,
//         path: '/manufacturer-websites',
//         button: 'Contact Us',
//         modal: true
//     },
// ];

// const HomePage2 = () => {
//     let message = useContext(UserContext)
//     const [AlldATA, setAlldATA] = useState(false)

//     const [showModal, setShowModal] = useState(false);
//     const [loader, setLoader] = useState()


//     const navigatePath = (item) => {
//         if ((localStorage.getItem('mytoken') === 'null' || localStorage.getItem('mytoken') === null) && item.id === 2) {
//             toast.error("You must login first")
//             navigate('/login-signup')
//         }
//         else {
//             navigate(item.path)
//         }
//     }

//     const contactSalesRep = async (data) => {
//         setLoader(true)
//         try {
//             let response = await API.contactSalesRep(data)
//             if (response.success) {
//                 toast.success(response.message)
//             }
//             else {
//                 toast.error(response.data.message)
//             }
//         }
//         catch (error) {
//             toast.error(error.message)
//         }
//         finally {
//             setLoader(false)
//             setShowModal(false)
//         }
//     }

//     const navigate = useNavigate();
//     return (
//         <React.Fragment>
//             {/* Banner */}
//             <section className='homebanner'>
//                 <img src={homePageBanner} alt='' />
//                 <div className='overlay'>
//                     <div className='container'>
//                         <img className='rectIcon' src={rectIcon} alt="" />
//                         <div className='homepageHeading'>
//                             <h1>CREATIVE</h1>
//                             <h1>PROJECTS</h1>
//                             {/* <h1>CREATIVE<br />PROJECTS</h1> */}
//                         </div>
//                         <div className='searchButton'>
//                             <button onClick={() => navigate('/products')}>SEARCH FOR PRODUCTS</button>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//             {/* <section className='banner'>
//                 <div className='container'>
//                     <div className='row'>
//                         <div className='banner__text'>
//                             <h2>plan/space®</h2>
//                             <p>The leading manufacturers at the tip of your fingers. Create and collaborate on your
//                 upcoming project by utilizing the most in demand products on the market. Plan/Space gives you the tools to create an all in one plumbing fixture package curated to your vision.</p>
//                             <Button type="primary" value="Search for Products" click={() => navigate('/products')} />
//                         </div>

//                         <div className='banner__img'>
//                             <div className='row'>
//                                 <div className='img'>
//                                     <img src={Images.image.bannerImg1} alt='' />
//                                 </div>
//                                 <div className='img'>
//                                     <img src={Images.image.bannerImg2} alt='' />
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>

//             <section className='services'>
//                 <div className='container'>
//                     <div className='row'>
//                         {serviceData.map((item) => (
//                             <div className='services__box' key={item.id}>
//                                 <div className='cover'>
//                                     <img src={item.img} alt='' />
//                                     <div className='text'>
//                                         <span className='number'>0{item.id}</span>
//                                         <h3>{item.title}</h3>
//                                         <p>{item.text}</p>
//                                         {item.modal ? 
//                                             <Button value={item.button} type="secondary" click={() =>  setShowModal(true)} />
//                                             :
//                                             <Button value={item.button} type="secondary" click={() =>  navigatePath(item)} />
//                                         }
//                                     </div>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </section> */}
//             {/* <ContactSaleModal click={() => setShowModal(!showModal)} show={showModal} contact={contactSalesRep} loader={loader} /> */}
//         </React.Fragment>
//     )
// }
// export default HomePage2;


import React, { useState } from "react";
import classes from "./home.module.scss";
import { featuresData, installingData, lookingData } from "../constants";
import Button from "components/button";
import { useNavigate } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import { ParallaxBanner } from "react-scroll-parallax";


const apartList = [
  {
    image: '/images/apart-img1.png',
    title: "Code-compliant by design",
    text: 'All our systems are engineered to meet the highest standards and are approved in over 4,200 jurisdictions across North America. From ASME and CSA to PDI, every unit is built to pass inspection—no exceptions.'
  },
  {
    image: '/images/apart-img2.jpg',
    title: "Built to last in real conditions",
    text: 'We use high-performance materials like HDPE and ductile iron to ensure durability in the most demanding environments. Our products stand up to corrosion, high temperatures, and heavy traffic with confidence.'
  },
  {
    image: '/images/apart-img3.png',
    title: "Designed for the field",
    text: 'We build with the installer in mind. Integrated flow control, sample ports, and submittal-ready documentation come standard—so your project stays on time, on budget, and up to code.'
  },
  {
    image: '/images/apart-img4.jpg',
    title: "Support at every scale",
    text: 'From one-off installs to multi-site rollouts, our team offers expert guidance from product selection to technical support. We’re here to help you get it right—every step of the way.'
  },
];

const HomePage2 = () => {
  const [currentTab, setCurrentTab] = useState("Flow Rate");
  const navigate = useNavigate();


  const onProjectCreate = () => {
    const isLoggedIn = localStorage.getItem("mytoken");
    console.log("itemized", isLoggedIn, !isLoggedIn);
    if (!isLoggedIn) {
      navigate("login-signup");
    } else {
      navigate("/projects");
    }
  };

  const onClickSizeInterceptor = () => {
    const isLoggedIn = localStorage.getItem("mytoken");
    console.log("itemized", isLoggedIn, !isLoggedIn);
    if (!isLoggedIn) {
      navigate("/createProjectForm");
    } else {
      navigate('/createQuotationProjectForm')
    }
  };
  return (
    <section className={classes.wrapper}>
      {/* Banner */}
      <div className={classes.banner}>
        <img
          src="/images/bigbanner3.png"
          alt=""
          className={classes.banner__bg}
        />
        <div className="container">
          <div className={classes.banner__row}>
            <div className={classes.banner__text}>
              {/* <h1 className={classes.banner__ttl}>
                Find Your Perfect Grease Interceptor <br />
                &mdash; In Seconds
              </h1> */}
              <h1 className={classes.banner__ttl}>
                Welcome to size my interceptor
              </h1>
              <div className={classes.banner__des}>
                {/* <p>
                  MIFAB's smart sizing tool delivers code-compliant recommendations instantly.
                </p> */}
                <p>MIFAB’s smart sizing tool gives guidance that may assist with code compliance, based on local requirements. Contact us at  <a href='mailto:sales@mifab.com'>sales@mifab.com</a> this to find out if we meet your code .</p>
              </div>


              <div className={classes.banner__btns}>
                <button
                  type="button"
                  onClick={() => navigate('/createProjectForm')}
                  className={`${classes.btn} ${classes.btn__primary}`}
                >
                  Start Sizing Now
                </button>
                <button
                  type="button"
                  onClick={() => navigate('/products')}
                  className={`${classes.btn} ${classes.btn__outline}`}
                >
                  View Products
                </button>
              </div>

              <div className={classes.banner__subtext}>
                <p>Fast &bull; Accurate &bull; Compliant</p>
              </div>

              <div className={classes.banner__compliance}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" fill="black" />
                  <path d="M8 12L11 15L16 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span>Compliant with local codes across North America</span>
              </div>
            </div>
            <div className={classes.banner__img}>
              <img src="/images/bannernew9.png" alt="" />
            </div>
          </div>
        </div>
      </div>

      <section className={classes.sizingSimple}>
        <div className="container">
          <h2 className={classes.sizingSimple__ttl}>Interceptor Sizing Made Simple</h2>
          <div className={classes.sizingSimple__row}>
            <div className={classes.sizingSimple__card}>
              <img src="/images/locationBased.png" alt="Location Based" />
              <h3>Location Based</h3>
              <p>Size by installation location and conditions</p>
            </div>
            <div className={classes.sizingSimple__card}>
              <img src="/images/entypo_tools.png" alt="Fixture Based" />
              <h3>Fixture Based</h3>
              <p>Add fixtures and calculate flow automatically</p>
            </div>
            <div className={classes.sizingSimple__card}>
              <img src="/images/mdi_graph-box-multiple-outline.png" alt="Accurate Results" />
              <h3>Accurate Results</h3>
              <p>Get the right interceptor for your project</p>
            </div>
            <div className={classes.sizingSimple__card}>
              <img src="/images/pajamas_doc-text.png" alt="Spec Ready" />
              <h3>Spec Ready</h3>
              <p>Download specs, CAD drawings & submittals</p>
            </div>
          </div>
        </div>
      </section>

      <section className={classes.howItWorks}>
        <div className="container">
          <div className={classes.howItWorks__inner}>
            <h2 className={classes.howItWorks__ttl}>How It Works</h2>
            <div className={classes.howItWorks__row}>
              <div className={classes.howItWorks__step}>
                <span className={classes.howItWorks__number}>1</span>
                <div className={classes.howItWorks__icon}>
                  <img src="/images/project_detail.png" alt="Step 1" />
                </div>
                <h3>Enter Project Detail</h3>
                <p>Size by installation location and conditions</p>
              </div>
              <div className={classes.howItWorks__step}>
                <span className={classes.howItWorks__number}>2</span>
                <div className={classes.howItWorks__icon}>
                  <img src="/images/marketeq_water-tap.png" alt="Step 2" />
                </div>
                <h3>Add Fixture</h3>
                <p>Add fixtures and calculate flow automatically</p>
              </div>
              <div className={classes.howItWorks__step}>
                <span className={classes.howItWorks__number}>3</span>
                <div className={classes.howItWorks__icon}>
                  <img src="/images/solution.png" alt="Step 3" />
                </div>
                <h3>Get Your Solution</h3>
                <p>Download specs, CAD drawings & submittals</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <div className={classes.parallaxBanner}>
        <ParallaxBanner
          layers={[{ image: '/images/ParallaxBanner.jpg', speed: 5 }]}
          className={classes.parallaxBannerInner}
        />
      </div> */}

      <div className={classes.parallaxBanner}>
        <ParallaxBanner
          layers={[{ image: '/images/ParallaxBanner.jpg', speed: 5 }]}
          className={classes.parallaxBannerInner}
        />

        <div className={classes.parallaxBanner__content}>
          <button
            type="button"
            onClick={() => onClickSizeInterceptor()}
            className={`${classes.btn} ${classes['btn__light']}`}
          >
            Size your Interceptor
            <span><IoIosArrowForward /></span>
          </button>
        </div>
      </div>


      <div className={classes.built}>
        <div className="container">
          <div className={classes.built__row}>
            <div className={classes.built__text}>
              <h3>Built for real-world kitchens</h3>
              <p>Whether you operate a quick-service restaurant, hotel, hospital, or grocery deli, this tool helps your team save time, avoid errors, and stay compliant.</p>
              <button type="button" onClick={onProjectCreate} className={classes.btn}>Create New Project <span><IoIosArrowForward /></span></button>
            </div>
            <div className={classes.built__img}>
              <img src="/images/built-img.png" alt="" />
            </div>
          </div>
        </div>
      </div>

      <div className={classes.mimia}>
        <div className="container">
          <div className={classes.mimia__row}>
            <div className={classes.mimia__text}>
              <h3>Miami-Dade Derm Interceptors</h3>
              <p>sizing for MIAMI-DADE all approved 99% units are in the calculations under the MIAMI DADE zip codes
                {/* <span className={classes.zipCodes}>
                  (33012, 33015, 33186, 33157, 33033, 33027, 33178, 33142, 33177, 33032, 33161, 33165, 33196, 33125, 33176, 33018, 33175, 33193, 33126, 33016, 33179, 33147, 33162, 33155, 33169, 33010, 33160, 33172, 33014, 33134, 33055, 33030, 33056, 33139, 33183, 33135, 33141, 33180, 33121, 33174, 33013, 33130, 33150, 33133, 33143, 33156, 33173, 33127, 33145, 33054, 33144, 33138, 33185, 33166, 33167, 33189, 33168, 33140, 33184, 33131, 33137, 33181, 33034, 33187, 33136, 33154, 33146, 33149, 33035, 33129, 33182, 33170, 33190, 33132, 33037, 33128, 33110, 33031, 33194, 33158, 34141, 33122, 33148, 33199, 33039, 33109, 33191, 33107, 33159, 33256, 33017, 33222, 33206, 33198, 33195, 33243, 33255, 33265, 33002, 33011, 33164, 33163, 33188, 33192, 33197, 33233, 33231, 33238, 33234, 33242, 33239, 33245, 33247, 33257, 33261, 33269, 33266, 33283, 33280, 33299, 33296, 33090, 33092, 33101, 33102, 33112, 33111, 33116, 33114, 33119, 33124, 33152, 33151, 33153, 33106)
                </span> */}
              </p>

            </div>
            <div className={classes.mimia__img}>
              <img src="/images/MIAMI-DADE-COUNTY-removebg-preview.png" alt="" />
            </div>
          </div>
        </div>
      </div>

      <div className={classes.trusted}>
        <div className="container">
          <div className={classes.trusted__row}>
            <div className={classes.trusted__text}>
              <h4>Trusted in every <br />kitchen that counts</h4>
              <h2>From bustling restaurants to high-volume institutions, MIFAB solutions support:</h2>
              <p>Restaurants • Cafés • Hotels • Hospitals • Supermarkets • Schools • Correctional Facilities • Catering Hubs • Shared Kitchens • Food Processing Plants</p>
              {/* <button type="button" className={classes.btn} onClick={()=> navigate('/products')}>
                See Full List of Applications
                <span><IoIosArrowForward /></span>
              </button> */}
            </div>
            <div className={classes.trusted__img}>
              <img src="/images/trusted-img.jpg" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div className={classes.bar} />

      <div className={classes.imageBox}>
        <div className={classes.imageBoxItem}>
          <div className={classes.imageBoxImg}>
            <img src="/images/home-video-img.jpg" alt="" />
            <video autoPlay muted playsInline loop>
              <source src="/images/home-video.mp4" type="video/mp4" />
            </video>
          </div>
          <div className={classes.imageBoxText}>
            <div>
              <h4>HOW IT WORKS</h4>
              <h2>Powered by engineering. Designed for<br /> performance.</h2>
            </div>
          </div>
        </div>
        <div className={classes.imageBoxItem}>
          <div className={classes.imageBoxImg}>
            <img src="/images/home-video-img1.jpg" alt="" />
          </div>
          <div className={classes.imageBoxText}>
            <div>
              <p>Discover the technology behind our high-performance interceptor system. This short video takes you inside the unit—showing how intelligent flow management, advanced internal geometry, and durable materials work together to capture and contain grease, oil, and solids with precision.</p>
              <button type="button" className={classes.btn}>
                Specification sheet
                <span><IoIosArrowForward /></span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className={classes.sizing}>
        <div className="container">
          <div className={classes.sizing__row}>
            <div className={classes.sizing__text}>
              <h4>SIZING</h4>
              <h2>Smart sizing made simple</h2>
              <p>Whether you’re sizing by fixtures or by restaurant type, our calculation tool ensures you get the right grease interceptor for your specific needs. In just three guided steps, you’ll determine your flow rate, estimate your grease production, and define the ideal capacity—backed by real data and built-in code compliance.</p>
              <img src="/images/sizing-img1.png" alt="" />
            </div>
            <div className={classes.sizing__img}>
              <img src="/images/sizing-img2.png" alt="" />
            </div>
          </div>
        </div>
      </div>

      <div className={classes.installing}>
        <div className="container">
          <div className={classes.installing__row}>
            <div className={classes.installing__box}>
              <img src="/images/installing-img1.png" alt="" />
            </div>
            <div className={classes.installing__box}>
              <h4>INSTALLING</h4>
              <h2>Ready-to-fit specs and install data</h2>
              <p>Our system generates ready-to-use PDFs that include all your sizing calculations and installation details, so you can confidently integrate the unit into your plans. Whether you're installing it buried outdoors or within a high-traffic zone, we provide the exact specifications you need: compacted aggregate base, backfill requirements, concrete slab thickness, pipe connections, and H-20 load-rated covers. No guesswork—just a seamless fit for your application.</p>
            </div>
          </div>
        </div>
      </div>

      <div className={classes.apart}>
        <div className="container">
          <h2>What sets us apart</h2>
          <div className={classes.apart__row}>
            {apartList.map((item, idx) => (
              <div key={`apart__${idx}`}>
                <img src={item.image} alt={item.title} />
                <h4>{item.title}</h4>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className={classes.getStart}>
        <div className="container">
          <div className={classes.getStart__row}>
            <div>
              <h2>Ready to get started?</h2>
            </div>
            <div>
              <p>Need support on a multi-site rollout or a custom install? Our team is here to help.</p>
              <button type="button" className={`${classes.btn} ${classes.btn__light}`} onClick={() => navigate('/contact')}>
                Contact Us
                <span><IoIosArrowForward /></span>
              </button>
            </div>
          </div>
        </div>
      </div>



    </section>
  );
};

export default HomePage2;
